import { faCircleDot } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
import styled, { css } from 'styled-components';

const Wrapper = styled.label`
  display: inline-flex;
  align-items: baseline;
`;

const Input = styled.input`
  width: 0;
  height: 0;
` as FC<React.HTMLProps<HTMLInputElement>>;

const RenderedRadioButton = styled.div<{ padRight?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  /*
   * Ikonen är 1em stor. Ärver den radens font-size hamnar marginalen runt ringen på en
   * halv pixel — 15px glyf i den 18px inre rutan ger 1,5px per sida — och halvpixeln
   * avrundas åt olika håll på de två sidorna, så ringen ser ut att sitta snett. Låst
   * till 12px blir det 3 hela pixlar runt om.
   */
  font-size: 12px;
  line-height: 1;
  border: 1px solid ${({ theme }) => theme.colors.border.primary};
  border-radius: ${({ theme }) => theme.sizes.radius.input}px;
  cursor: pointer;

  ${({ padRight }) =>
    padRight &&
    css`
      margin-right: 5px;
    `}

  input+ & {
    color: ${({ theme }) => theme.colors.foreground.primary};

    & > * {
      opacity: 0.2;
    }
  }

  input:checked + & {
    background-color: ${({ theme }) => theme.colors.background.button};
    border-color: ${({ theme }) => theme.colors.background.button};
    color: ${({ theme }) => theme.colors.foreground.button};

    & > * {
      opacity: 1;
    }
  }
`;

interface Props extends React.HTMLProps<HTMLInputElement> {}

const RadioButton = React.forwardRef<HTMLInputElement, Props>(
  ({ type, children, className, ...inputProps }, ref) => {
    return (
      <Wrapper className={className}>
        <Input {...inputProps} ref={ref} type="radio" />
        <RenderedRadioButton padRight={!!children}>
          <FontAwesomeIcon icon={faCircleDot} />
        </RenderedRadioButton>
        {children}
      </Wrapper>
    );
  }
);

export default RadioButton;
